import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import cx from 'classnames';
import _map from 'lodash/map';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';

// Components
import InputTableCell from '../inputTableCell';
import FontIcon, { SIZES } from '../../../../atoms/FontIcon';

// Helpers
import { getCellError } from './inputTableRow.helpers';

// Styles
import s from './inputTableRow.module.scss';
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();
var InputTableRow = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputTableRow, _PureComponent);
  var _super = _createSuper(InputTableRow);
  function InputTableRow() {
    var _this;
    _classCallCheck(this, InputTableRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getCellError", defaultMemoize(getCellError));
    _defineProperty(_assertThisInitialized(_this), "getCellProps", defaultMemoize(function (rowData, rowIndex, columnConfig) {
      var getTdProps = _this.props.getTdProps;
      var cellProps = getTdProps(rowData, rowIndex, columnConfig);
      return cellProps;
    }));
    _defineProperty(_assertThisInitialized(_this), "renderCell", function () {
      var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COLUMN_CONFIG;
      var _this$props = _this.props,
        rowData = _this$props.rowData,
        rowIndex = _this$props.rowIndex,
        onAction = _this$props.onAction,
        errors = _this$props.errors;
      var cellProps = _this.getCellProps(rowData, rowIndex, columnConfig);
      var cellWidth = columnConfig.getWidth();
      var error = _this.getCellError(columnConfig, errors);
      var cellClassName = cx(_defineProperty({}, s.cell__expand, !cellWidth), s.cell);
      return /*#__PURE__*/React.createElement(InputTableCell, _extends({}, cellProps, {
        columnConfig: columnConfig,
        rowData: rowData,
        rowIndex: rowIndex,
        onAction: onAction,
        className: cellClassName,
        error: error
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderDragAndDropIcon", function () {
      return /*#__PURE__*/React.createElement(FontIcon, {
        size: SIZES.S,
        className: s.dragAndDropIcon
      }, "icon-drag-and-drop");
    });
    return _this;
  }
  _createClass(InputTableRow, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        columns = _this$props2.columns,
        rowStyle = _this$props2.rowStyle,
        showDraggableIcon = _this$props2.showDraggableIcon,
        highlightRowOnFocus = _this$props2.highlightRowOnFocus,
        rowRef = _this$props2.rowRef,
        className = _this$props2.className;
      var rowClass = cx(s.row, className, _defineProperty({}, s.hightlightRow, highlightRowOnFocus));
      return /*#__PURE__*/React.createElement("div", {
        className: rowClass,
        style: rowStyle,
        ref: rowRef
      }, showDraggableIcon && this.renderDragAndDropIcon(), _map(columns, this.renderCell));
    }
  }]);
  return InputTableRow;
}(PureComponent);
InputTableRow.propTypes = {
  rowData: PropTypes.object,
  rowIndex: PropTypes.number,
  columns: PropTypes.array,
  getTdProps: PropTypes.func,
  onAction: PropTypes.func,
  errors: PropTypes.object,
  rowStyle: PropTypes.object,
  showDraggableIcon: PropTypes.bool,
  highlightRowOnFocus: PropTypes.bool,
  rowRef: PropTypes.object,
  className: PropTypes.string
};
InputTableRow.defaultProps = {
  rowData: EMPTY_OBJECT,
  rowIndex: 0,
  columns: EMPTY_ARRAY,
  errors: EMPTY_OBJECT,
  getTdProps: _noop,
  onAction: _noop,
  rowStyle: EMPTY_OBJECT,
  showDraggableIcon: false,
  highlightRowOnFocus: false,
  rowRef: null,
  className: undefined
};
export default InputTableRow;